import { render, staticRenderFns } from "./AccessStepper.vue?vue&type=template&id=8bfd7064&scoped=true&"
import script from "./AccessStepper.vue?vue&type=script&lang=js&"
export * from "./AccessStepper.vue?vue&type=script&lang=js&"
import style0 from "./AccessStepper.vue?vue&type=style&index=0&id=8bfd7064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfd7064",
  null
  
)

export default component.exports